const namespace = 'components.flow_creation_notification.';

const translations = {
    createdSuccessfully: `${namespace}created_successfully`,
    inProgress: `${namespace}in_progress`,
    totalCreated: `${namespace}total_created`,
};

export { translations };
